import { BlockTypeEnum } from './blockType'

// i18n keys, not display text. Builder drops translate them before saving, but some creation paths
// (sub-workflow and child-request start blocks, seed scripts) store the key itself as `payload.label`.
export const BlockDefaultLabel: Record<BlockTypeEnum, string> = {
  [BlockTypeEnum.APPROVAL]: 'block-default-label.task',
  [BlockTypeEnum.CHILD_REQUEST_START]: 'block-default-label.child-request-start',
  [BlockTypeEnum.SUB_WORKFLOW_START]: 'block-default-label.sub-workflow-start',
  [BlockTypeEnum.SUPPLIER_ONBOARDING]: 'block-default-label.supplier-portal',
  [BlockTypeEnum.MILESTONE]: 'block-default-label.milestone',
  [BlockTypeEnum.NOTIFICATION]: 'block-default-label.notify',
  [BlockTypeEnum.ENGAGEMENT]: 'block-default-label.engagement',
  [BlockTypeEnum.HTTP]: 'block-default-label.post-http',
  [BlockTypeEnum.BUDGET_APPROVAL]: 'block-default-label.budget-approval',
  [BlockTypeEnum.INTAKE]: 'block-default-label.intake',
  [BlockTypeEnum.RENEWAL_ASSESSMENT]: 'block-default-label.renewal-assessment',
  [BlockTypeEnum.EXTERNAL_OPERATION]: 'block-default-label.external-operation',
  [BlockTypeEnum.EXTERNAL_PROCEDURE]: 'block-default-label.external-procedure',
  [BlockTypeEnum.CREATE_RENEWAL]: 'block-default-label.create-renewal',
  [BlockTypeEnum.COMMIT_SUPPLIER_DATA]: 'block-default-label.commit-supplier-data',
  [BlockTypeEnum.CREATE_AGREEMENT]: 'block-default-label.create-agreement',
  [BlockTypeEnum.CANCEL_AGREEMENT]: 'block-default-label.cancel-agreement',
  [BlockTypeEnum.CANCEL_ASSESSMENTS]: 'block-default-label.cancel-assessments',
  [BlockTypeEnum.CREATE_PO]: 'block-default-label.create-po',
  [BlockTypeEnum.RFX]: 'block-default-label.rfx',
  [BlockTypeEnum.AUCTION]: 'block-default-label.auction',
  [BlockTypeEnum.CREATE_ASSESSMENT]: 'block-default-label.create-assessment',
  [BlockTypeEnum.PRICE_BENCHMARK]: 'block-default-label.price-benchmark',
  [BlockTypeEnum.DATA_TRANSFORMATION]: 'block-default-label.data-transformation',
  [BlockTypeEnum.WAITING]: 'block-default-label.waiting',
  [BlockTypeEnum.SUPPLIER_ONLINE_RESOURCES]: 'block-default-label.supplier-online-resources',
  [BlockTypeEnum.INHERENT_RISK_ASSESSMENT]: 'block-default-label.inherent-risk-assessment',
  [BlockTypeEnum.NOTIFY_SLACK]: 'block-default-label.notify-slack',
}
